<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 消防安全维修汇总
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="文件名称:">
                <el-input v-model="seefrom.fileName" placeholder="请输入文件名称"></el-input>
              </el-form-item>
              <el-form-item label="年份:">
                <el-select :popper-append-to-body="false" v-model="seefrom.year" placeholder="请选择年份" style="width:100%" clearable>
                  <el-option v-for="(item,index) in yearList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="月份:">
                <el-select :popper-append-to-body="false" v-model="seefrom.month" placeholder="请选择年份" style="width:100%" clearable>
                  <el-option v-for="(item,index) in monthList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" :width="width" v-for="({prop,label,align, width}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link icon="iconfont iconedit" type="text" size="small" @click="download(scope.row)">下载</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getLatestYear } from 'utils'
export default {
  name: 'maintainSummary',
  data() {
    return {
      form_jsgl: {},
      items: [],
      yearList: [],
      monthList: [
        {
          label: '01',
          value: 1
        },
        {
          label: '02',
          value: 2
        },
        {
          label: '03',
          value: 3
        },
        {
          label: '04',
          value: 4
        },
        {
          label: '05',
          value: 5
        },
        {
          label: '06',
          value: 6
        },
        {
          label: '07',
          value: 7
        },
        {
          label: '08',
          value: 8
        },
        {
          label: '09',
          value: 9
        },
        {
          label: '10',
          value: 10
        },
        {
          label: '11',
          value: 11
        },
        {
          label: '12',
          value: 12
        }
      ],
      tabName: 'jsgl',
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      currentSize: 10
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'fileName',
          label: '文件名称',
          width: 350
        },
        {
          prop: 'areaName',
          label: '所属区域'
        },
        {
          prop: 'year',
          label: '年份'
        },
        {
          prop: 'month',
          label: '月份'
        },
        {
          prop: 'createTime',
          label: '生成时间'
        }
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable')
  },
  methods: {
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.currentSize = val
      this.currentPage = 1
      this.getTableData()
    },
    //查询表格数据
    getTableData() {
      this.$axiosget('extra/maintenanceRepairTask/collect/page', {
        params: {
          pageSize: this.currentSize,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    changeTab(val) {
      this.activeName = val
    },
    download(row) {
      let fileAddr = row.url
      location.href = process.env.API_HOST + fileAddr
    }
  },
  created() {
    this.getTableData()
    this.yearList = getLatestYear(2, 0)
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/maintainSummary/index.vue